import { ChildRelationshipType } from 'src/app/common/enums/enums';
import { IndividualViewBase } from 'src/app/common/models/individual/individual-view-base';

export class FamilyViewModel {
    individual: IndividualViewBase;
    spouse: IndividualViewBase;
    relationshipType: ChildRelationshipType;
    children: FamilyViewModel[];
    familyId: number;
}